const SortIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 6H21M6 12H18M10 18H14" stroke="#111827" strokeWidth="2" strokeLinecap="round"/>
  </svg>
)

export default SortIcon
